import { useEffect, useMemo, useRef } from 'react';
import { hasFilterSelectedValue } from '../../../components/filters/hooks/common.hook';
import { useFilterResetCallback } from '../../../components/filters/hooks/use-filter-reset.hook';
import { FilterSelectedValue } from '../../../hooks/filters/interfaces/filter-selected-value.interface';

type MetaCategoryKey = string | null;

const toKey = (metaCategory: FilterSelectedValue): MetaCategoryKey => {
  const sel = hasFilterSelectedValue(metaCategory);
  return sel ? sel.values.map((i) => i.value).join(',') : null;
};

export const useResetFiltersOnMetaCategoryChange = (
  metaCategory: FilterSelectedValue | undefined,
  filterSelection?: FilterSelectedValue[],
) => {
  const { handleResetFilter } = useFilterResetCallback();
  const key = useMemo(() => toKey(metaCategory!), [metaCategory]);
  const prevKey = useRef<MetaCategoryKey | undefined>(undefined);

  useEffect(() => {
    const prev = prevKey.current;
    prevKey.current = key;

    if (prev === undefined) return;
    if (prev === key) return;
    if (prev === null) return;
    if (key === null) return;

    handleResetFilter(filterSelection);
  }, [key, filterSelection, handleResetFilter]);
};
